import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="relative z-10 py-12 font-rajdhani">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-orbitron font-bold mb-4 text-xl tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple drop-shadow-[0_0_5px_rgba(0,255,255,0.5)]">Bigotes Streaming</h3>
            <p className="text-gray-300 opacity-90">
              Tu destino para licencias de streaming y juegos. Ofertas exclusivas y los mejores precios garantizados.
            </p>
          </div>
          
          <div>
            <h3 className="font-orbitron font-bold mb-4 text-xl tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple drop-shadow-[0_0_5px_rgba(0,255,255,0.5)]">Enlaces</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center gap-2 hover:drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center gap-2 hover:drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-orbitron font-bold mb-4 text-xl tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple drop-shadow-[0_0_5px_rgba(0,255,255,0.5)]">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/politicas/privacidad" className="text-gray-400 hover:text-white transition-colors duration-300 hover:drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/politicas/cookies" className="text-gray-400 hover:text-white transition-colors duration-300 hover:drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/politicas/devoluciones" className="text-gray-400 hover:text-white transition-colors duration-300 hover:drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]">
                  Política de Devoluciones
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-orbitron font-bold mb-4 text-xl tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple drop-shadow-[0_0_5px_rgba(0,255,255,0.5)]">Contacto</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 opacity-90 flex items-center gap-2">
                Email: info@bigotesstreaming.com
              </li>

              <li className="text-gray-300 opacity-90 flex items-center gap-2">
                WhatsApp: +34 632 22 08 54
              </li>
              <li className="text-gray-300 opacity-90">
                Horario: Lunes a Domingo
                <br />
                9:00 - 21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} Bigotes Streaming. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/politicas/privacidad" className="text-gray-500 hover:text-white text-sm transition-colors">
                Privacidad
              </Link>
              <Link to="/politicas/cookies" className="text-gray-500 hover:text-white text-sm transition-colors">
                Cookies
              </Link>
              <Link to="/politicas/devoluciones" className="text-gray-500 hover:text-white text-sm transition-colors">
                Devoluciones
              </Link>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-neon-blue/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
      </div>
    </footer>
  );
}

export default Footer;